import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
//获取领用申请列表
export async function getPickingReqList(params) {
    return post(erpserver+'/pickingList/getPickingReqList', params, true)
}
//获取仓库
export async function getWarehouseList(params) {
    return post(erpserver+'/currency/getWarehouseList', params, true)
}
// 获取申请人
export async function getPersonList(params) {
    return post(erpserver+'/currency/getPersonList', params, true);
}
// 获取领用部门
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true);
}
// 获取公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
// 获取产品
export async function getProductList(params) {
    return post(erpserver+'/output/getProductList', params, true);
}

// 获取领料单详情
export async function getPickingList(params) {
    return post(erpserver+'/pickingList/getPickingList', params, true);
}
// 保存
export async function savePickingList(params) {
    return post(erpserver+'/pickingList/savePickingList', params, true);
}// 删除
export async function delPickingList(params) {
    return post(erpserver+'/pickingList/delPickingList', params, true);
}
